<template>
  <div class="video-wrap">
    <VResponsive :aspect-ratio="16/9">
      <VideoPlayer
        v-model="currentTime"
        :video-url="interview.video.url"
        :poster="poster"
      />
    </VResponsive>
  </div>
</template>

<script>
import VideoPlayer from '@huntica/huntica-interview-module/src/components/VideoPlayer.vue';
import { interviewImageType } from '@/enums';

export default {
  name: 'CandidateInterviewOffice',
  components: { VideoPlayer },
  model: {
    prop: 'time',
    event: 'input',
  },
  props: {
    time: {
      type: Number,
      required: true,
    },
    interview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentTime: {
      get() {
        return this.time;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    poster() {
      const poster = this.interview.images.find((p) => p.type === interviewImageType.H296);

      if (poster) {
        return poster.url;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
  .video-wrap {
    display: flex;
    padding: 0.625rem;
    background-color: #f5f5f5;
    border-radius: 0 0 0.5rem 0.5rem;
  }
</style>
